import React from 'react';
import { createRoot } from 'react-dom/client';
import LoanTypesPage from '../components/LoanTypesPage';
import Layout from '../components/Layout';
import CookieConsent from '../components/CookieConsent';
import '../../assets/stylesheets/application.tailwind.css';
import '../i18n/config';
import { ensureDataLayer } from '../utils/gtm';

ensureDataLayer();

function LoanTypesApp() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <Layout>
        <LoanTypesPage />
        <CookieConsent />
      </Layout>
    </div>
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('loan-types-page');
  if (container) {
    const root = createRoot(container);
    root.render(<LoanTypesApp />);
  }
});
